<div class="card-body d-flex flex-column gap-4">
    <div class="row content-row mx-0" *ngFor="let asset of assets">
        <div class="col-lg-3">
            <dynamic-field class="l-name" [props]="props?.Name" [canBeEmpty]="true">
                <span HJSuppress class="l-name-highlighted">{{asset?.name}}</span>
            </dynamic-field>
            <dynamic-field class="l-description" [props]="props?.Description" [canBeEmpty]="true">
                <span class="l-description-highlighted">{{asset?.description}}</span>
            </dynamic-field>
            <dynamic-field class="l-description" [props]="props?.Uid" [canBeEmpty]="true">
                {{'contractDetail.assets.vin' | translate}}:
                <span HJSuppress class="l-description-highlighted">{{asset?.uid}}</span>
            </dynamic-field>
        </div>

        <div class="col-lg-3 plate-col">
            <dynamic-field 
                *ngIf="asset.deliveryStatus !== AssetDeliveryStatus.ESTIMATED" 
                [props]="props?.Number" 
                [canBeEmpty]="true"
            >
                <div class="l-header">
                    {{'contractDetail.assets.plateNumber' | translate}}
                </div>
                <div HJSuppress class="l-value">
                    {{asset?.number}}
                </div>
            </dynamic-field>

            <div *ngIf="asset.deliveryStatus === AssetDeliveryStatus.ESTIMATED">
                <div class="l-header">
                    {{'contractDetail.assets.deliveryLocation' | translate}}
                </div>
                <div HJSuppress class="l-value">
                    {{asset?.deliveryLocation}}
                </div>
            </div>
        </div>

        <div *ngIf="contract?.dictionaryContractType.code !== ContractType.OPERATIONAL_LEASING" class="col-lg-3 value-col">
            <dynamic-field *ngIf="asset.deliveryStatus !== AssetDeliveryStatus.ESTIMATED" [props]="props?.Value" [canBeEmpty]="true">
                <div class="l-header">
                    {{'contractDetail.assets.value' | translate}}
                </div>
                <div HJSuppress class="l-value">
                    {{ asset?.value | number:'1.2-2' }} 
                    {{asset?.currency}}
                </div>
            </dynamic-field>

            <div *ngIf="asset.deliveryStatus === AssetDeliveryStatus.ESTIMATED">
                <div class="l-header">
                    {{'contractDetail.assets.clientDelegate' | translate}}
                </div>
                <div *ngIf="asset.deliveryDelegateName" HJSuppress class="l-value">
                    <span class="me-1">{{asset?.deliveryDelegateName}}</span> 
                    <span class="l-value link-underline-primary-custom" (click)="openDelegateModal(asset)"
                    >{{'contractDetail.assets.change' | translate}}</span>
                </div>
                <div *ngIf="!asset.deliveryDelegateName" HJSuppress class="l-value">
                    <span class="link-underline-primary-custom" (click)="openDelegateModal(asset)">
                        {{'contractDetail.assets.addDelegate' | translate}}
                    </span>
                </div>
            </div>
        </div>

        <div *ngIf="contract?.dictionaryContractType.code === ContractType.OPERATIONAL_LEASING" class="col-lg-3 value-col">
            <dynamic-field [props]="props?.TrackedIndicators" [canBeEmpty]="true">
                <div class="l-header">
                    {{'contractDetail.assets.annualTrackedIndicators' | translate}}
                </div>
                <div class="l-value">
                    <span *ngFor="let track of asset.trackedIndicators; let last=last">
                        {{ isNumeric(track.value) ? (track.value | number:'1.') : track.value }}  {{track.dictionaryContractItemIndicator.value}} <span *ngIf="!last">/</span>
                    </span>
                </div>
            </dynamic-field>
        </div>

        <div 
            *ngIf="contract?.isActive && contract?.dictionaryContractType.code !== ContractType.CREDIT" 
            class="col-lg-3 d-flex align-items-center justify-content-center"
        >
            <span 
                *ngIf="asset.deliveryStatus === AssetDeliveryStatus.DELIVERED || !asset.deliveryStatus" 
                [ngbTooltip]="requestAccessWarnings.length > 0 ? warningMessagesTemplate : null" 
                tooltipClass="request-warning-tooltip opacity-100">
                <button class="btn outline-btn" (click)="redirectDocumentRequest(asset.contractId, asset.assetId)" [disabled]="requestAccessWarnings.length > 0">
                    {{'contractDetail.assets.documentRequest' | translate}}
                </button>
            </span>
            <div 
                *ngIf="asset.deliveryStatus === AssetDeliveryStatus.ESTIMATED" 
                class="badge badge-delivery-state state-estimated d-flex align-items-center gap-1">
                <div class="circle-box">
                    <div class="circle-box-inner"></div>
                </div>
                {{'contractDetail.assets.deliveryStatus.' + asset.deliveryStatus | translate}}:
                {{ asset.deliveryDate ? (asset.deliveryDate | localizedDate) : '' }}
            </div>
        </div>
    </div>
</div>

<ng-template #warningMessagesTemplate>
    <ul class="text-start ps-4 m-0">
        <li *ngFor="let message of requestAccessWarnings" [innerHtml]="message | translate"></li>
    </ul>
</ng-template>